.card {
  border: 1px solid var(--line);
  border-radius: var(--radius-sharp);
  background: var(--card);
  padding: 1.25rem 1.25rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.bigNumberButton {
  background: none;
  border: none;
  padding: 0;
  text-align: left;
  cursor: pointer;
}

.bigNumber {
  font-family: var(--font-display);
  font-size: 2.5rem;
  line-height: 1.05;
  color: var(--ink);
}

.bigNumberButton:hover .bigNumber {
  color: var(--teal-600);
  text-decoration: underline;
}

.empty {
  font-family: var(--font-display);
  font-size: 1.5rem;
  color: var(--muted);
  margin: 0;
}

.label {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--ink-soft);
  margin: 0;
}

.asOf {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  color: var(--muted);
}

/* --- grouped aggregate ---------------------------------------------------- */

.groupList {
  margin: 0;
  display: flex;
  flex-direction: column;
}

.groupRow {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 0.4rem 0;
  border-bottom: 1px solid var(--rule);
}

.groupRow dt {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  color: var(--ink-soft);
}

.groupValue {
  margin: 0;
  font-family: var(--font-display);
  font-size: 1.1rem;
  display: flex;
  gap: 0.5rem;
  align-items: baseline;
}

.runCount {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  color: var(--muted);
}

/* --- breakdown ------------------------------------------------------------ */

.rankedList {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.rankedRow {
  width: 100%;
  display: grid;
  grid-template-columns: minmax(8rem, 1fr) 6rem auto;
  align-items: center;
  gap: 0.75rem;
  padding: 0.4rem 0;
  border: none;
  border-bottom: 1px solid var(--rule);
  background: none;
  cursor: pointer;
  text-align: left;
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
}

.rankedRow:hover {
  background: var(--paper-2);
}

.rankedLabel {
  color: var(--ink);
}

/* Subtle relative magnitude, not a chart — the number beside it is the fact. */
.rankedBar {
  display: block;
  height: 0.4rem;
  background: var(--teal-300);
  border-radius: var(--radius-s);
  min-width: 2px;
}

.rankedValue {
  color: var(--ink-soft);
  justify-self: end;
}

/* --- refusal -------------------------------------------------------------- */

.refusal {
  border: 1px solid var(--line);
  border-radius: var(--radius-sharp);
  background: var(--card);
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 34rem;
}

.refusalHeader {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.refusalTitle {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--warn);
}

.refusalReason {
  font-family: var(--font-display);
  font-size: 1.1rem;
  margin: 0;
  color: var(--ink);
}

.refusalExplanation {
  margin: 0;
  color: var(--ink-soft);
}

.suggestions {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.4rem;
}

/* --- compare -------------------------------------------------------------- */

.compare {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.compareWide {
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
}
